import { defineStore } from 'pinia'
import { ref } from 'vue'

export type SyncedContentType = 'image' | 'video' | 'audio'

export const useContentSyncStore = defineStore('contentSync', () => {
  const assetVersions = ref<Record<SyncedContentType, number>>({ image: 0, video: 0, audio: 0 })
  const inspirationVersions = ref<Record<SyncedContentType, number>>({ image: 0, video: 0, audio: 0 })

  function isContentType(type: string): type is SyncedContentType {
    return type === 'image' || type === 'video' || type === 'audio'
  }

  function markAssetChanged(type: string) {
    if (isContentType(type)) {
      assetVersions.value[type] += 1
    }
  }

  function markInspirationChanged(type: string) {
    if (isContentType(type)) {
      inspirationVersions.value[type] += 1
    }
  }

  return { assetVersions, inspirationVersions, markAssetChanged, markInspirationChanged }
})
